import { MANUFACTURER_DEFAULTS } from '../../mockData';
import type { AircraftModelId, ServiceIntervalMap } from '../../types';

// OEM-recommended intervals for a model — used for OEM-default display and
// reset-to-default. Returns a copy so callers cannot mutate the source defaults.
export const getManufacturerDefaults = (model: AircraftModelId): ServiceIntervalMap => ({
    ...MANUFACTURER_DEFAULTS[model]
});
